import { Input, InputProps, PasswordInput } from 'ui';
import { Field, FieldConfig, useField } from 'formik';
import React from 'react';

type Props = Omit<InputProps, 'name'> & Omit<FieldConfig, 'value'>;

export const FormikInput = React.forwardRef<HTMLInputElement, Props>(
  ({ children, name, ...props }, ref) => {
    const [field, meta, helpers] = useField(name);

    return (
      <Field
        as={Input}
        {...props}
        {...field}
        error={meta.error}
        name={name}
        innerRef={ref}
      >
        {children}
      </Field>
    );
  },
);

export const FormikPasswordInput = React.forwardRef<HTMLInputElement, Props>(
  ({ children, name, ...props }, ref) => {
    const [field, meta, helpers] = useField(name);

    return (
      <Field
        as={PasswordInput}
        {...props}
        {...field}
        error={meta.error}
        name={name}
        innerRef={ref}
      >
        {children}
      </Field>
    );
  },
);
